import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-azure-services-list',
  templateUrl: './services-list.component.html',
  styleUrls: ['./services-list.component.css']
})
export class ServicesListComponent implements OnInit {

  public active!: number
  public showEmptyState: boolean = true
  public options: {[key: string]: string}[] = [
    {
      route: "webapps",
      name: "Web Apps",
      icon: "https://ms-azuretools.gallerycdn.vsassets.io/extensions/ms-azuretools/vscode-azureappservice/0.24.2/1654100793105/Microsoft.VisualStudio.Services.Icons.Default"
    }
]

  constructor() { }

  ngOnInit(): void {
  }

  public onClick(index: number) {    
    this.active = index
    this.showEmptyState = false
  }
}
